module.exports = __webpack_public_path__ + "assets/CutRectangle.9dcee79ecbf33e5701cf4f4722234e2c.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CutRectangle.gmt
// module id = 933
// module chunks = 0